<template>

    <Toast/>

    <MenuLogin/>

    <div class="px-6 surface-overlay relative">

        <div class="border-2 surface-border border-round surface-section flex-auto">

            <div class="flex flex-wrap">

                <div v-show="activeTab === 1" class="w-full lg:w-12 p-4 lg:p-7 surface-card">
                    <div class="text-900 text-2xl font-medium mb-6">Submit New Password</div>

                    <div class="field">
                        <p class="text-600 line-height-3 mt-0 mb-4">
                            Enter your new password below. If the
                            activation code matches our records, and it's still valid, the password will be reset. If not,
                            please start a new password request.
                        </p>
                    </div>

                    <div class="field">
                        <label for="activationCode" class="block text-900 font-medium mb-2">Activation Code</label>
                        <InputText id="activationCode" type="text" v-model="activationCode" placeholder="Activation Code"
                                   class="w-full mb-4"/>
                    </div>

                    <div class="field">
                        <label for="password1" class="block text-900 font-medium mb-2">New Password</label>
                        <InputText id="password1" :type="showPassword ? 'text' : 'password'" v-model="password1" placeholder="New Password"
                                   class="w-full mb-4"/>
                    </div>

                    <div class="field">
                        <label for="password2" class="block text-900 font-medium mb-2">Verify Password</label>
                        <InputText id="password2" :type="showPassword ? 'text' : 'password'" v-model="password2" placeholder="Verify Password"
                                   class="w-full mb-4"/>
                    </div>

                    <Button
                        label="Reset Password"
                        :disabled="!isFormValid"
                        class="p-3 w-full mt-auto custom-button"
                        :loading="submitted"
                        @click="processResetPassword"
                    />

                    <div class="field">
                        &nbsp;
                    </div>

                    <div class="flex align-items-center justify-content-between mb-6">
                        <div class="flex align-items-center">
                            <Checkbox id="showPasswordToggle" :binary="true" v-model="showPassword" class="mr-2"></Checkbox>
                            <label for="showPasswordToggle">Show Password</label>
                        </div>
                    </div>

                    <div class="mt-6 text-center text-600">
                        <a class="font-medium no-underline ml-2 text-teal-500 text-right cursor-pointer"
                           @click="handleCancel">Back to Login?</a>
                    </div>
                </div>

            </div>
        </div>

    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuLogin from "@/components/menu/authentication/MenuLogin.vue";
import UserService from "@/service/UserService";
import {useUserStore} from "@/stores/UserStore";

export default {
    components: {
        MenuLogin,
        IsoEvolveFooter
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        try {
            const userPingResponse = await UserService.getUserPing();
            console.log("[ForgotPasswordSubmission][mounted] System is active.");
            console.log("[ForgotPasswordSubmission][mounted] Data = ", userPingResponse);
        } catch (e) {
            console.log("[ForgotPasswordSubmission][mounted] System is NOT active.");
            console.log("[ForgotPasswordSubmission][mounted] Error = ", e);
            this.userStore.clearUser();
            this.$router.push("login");
            return;
        }

        this.activeTab = 1;
        this.submitted = false;
        this.activationCode = this.$route.query.code;
    },
    watch: {
        email(value) {
            this.emailError = !this.isValidEmail(value);
        },
    },
    computed: {
        isFormValid() {
            return (
                this.password1 &&
                this.password2 &&
                (this.password1 === this.password2)
            );
        },
    },
    data() {
        return {
            activeTab: 1,
            password1: null,
            password2: null,
            activationCode: null,
            passwordError: false,
            showPassword: false,
            submitted: false
        }
    },
    methods: {
        isValidEmail(email) {
            // Simple email validation regex
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        },
        async processResetPassword() {
            console.log("[ForgotPasswordSubmission][processResetPassword] this.email = ", this.email);

            this.submitted = true;

            if (this.isFormValid) {

                try {
                    console.log('[ForgotPasswordSubmission][processResetPassword] this.password1 = ', this.password1);

                    var resetPasswordRequestDto = {
                        activationCode: this.activationCode,
                        password: this.password1
                    };

                    const response = await UserService.resetPasswordActivation(resetPasswordRequestDto);
                    console.log('[ForgotPasswordSubmission][processResetPassword] Response = ', response);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Successfully reset password.',
                        life: 3000
                    });

                    setTimeout(() => {
                        window.location.href = "/#/login";
                    }, 1000); // 3000ms = 3 seconds

                } catch (error) {
                    console.error('[ForgotPasswordSubmission][processResetPassword] Error:', error);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to reset password. Please try again.',
                        life: 1000
                    });

                    setTimeout(() => {
                        window.location.href = "/#/login";
                    }, 1000); // 3000ms = 3 seconds

                }
            }

            this.submitted = false;
        },
        handleCancel() {
            this.activeTab = 1;
            console.log("[ForgotPasswordSubmission][handleCancel] Start of function. Redirecting to functionality.");
            this.$toast.add({
                severity: 'success',
                summary: 'Successful',
                detail: 'Reset Back to Login',
                life: 3000
            });

            setTimeout(() => {
                window.location.href = "/#/login";
            }, 1000); // 3000ms = 3 seconds
        }
    }
}
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
